import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./infrastructure-button.module.scss";
import { Layer } from "../../../interfaces/layer";
import { DebouncedFunction } from "../useDebounceLayers";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { setLoading } from "../../../services/reducers/map";

const InfrastructureButton = ({
  infrastructures,
  debounce,
  allSelected,
}: {
  infrastructures: Layer[];
  debounce: DebouncedFunction;
  allSelected: number[];
}) => {
  const [isHidden, setIsHidden] = useState<boolean>(true);

  useEffect(() => {
    let shown = true;

    if (infrastructures.length == 0) shown = false;

    for (let infrastructure of infrastructures) {
      if ((infrastructure.parentId ?? infrastructure.id) && shown) {
        shown = allSelected.includes(
          infrastructure.parentId ?? infrastructure.id,
        );
      }
    }

    setIsHidden(!shown);
  }, [allSelected]);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleClick = () => {
    infrastructures.forEach((item) => {
      const id = item.parentId ?? item.id;
      debounce(id, isHidden, "checkbox/infrastructure");
      dispatch(setLoading({ id: id, loading: true }));
    });
  };

  return (
    <button
      className={`${styles.infrastructureButton} ${isHidden ? styles.hidden : styles.shown}`}
      onClick={() => handleClick()}
    >
      {isHidden
        ? t("map-controls.showInfrastructure")
        : t("map-controls.hideInfrastructure")}
    </button>
  );
};

export default InfrastructureButton;
